<template>
  <div class="document-powerpoint-document">
    <!-- PowerPoint File Upload Area -->
    <div class="uploadOuter">
      <label :for="uploadId" class="btn btn-info" @click="onUploadClick">
        <i class="uil-upload"></i>
        {{ $t("general.upload") }}
      </label>
      <strong>{{ $t("general.or") }}</strong>
      <span :class="{ 'draging': isDragging }" class="dragBox">
        <i :class="icon"></i>
        {{ $t(contentTypeKey + "_drag_drop") }}
        <input :id="uploadId"
               :accept="acceptableFileType"
               draggable="true"
               type="file"
               @click="onUploadClick"
               @change="handleFileChange"
               @dragenter="isDragging = true"
               @dragleave="isDragging = false"
               @dragover.prevent
        />
      </span>

      <p style="margin-top: 10px; font-weight: bold;color:red;" v-html="$t('general.pptx_scorm_size_warning')"></p>
    </div>

    <!-- Edit modunda mevcut dosya preview -->
    <div v-if="isEditMode && existingFile" class="mt-4">
      <p>
        <div class="file-info">
          <div>{{ $t('general.format') }} : <span>{{ existingFile.name.split(".").pop().toUpperCase() }}</span></div>
          <div>{{ $t('general.document_name') }}: <span> {{ existingFile.name.toUpperCase() }} </span></div>
          <div>{{ $t('general.download_link') }}: <a :href="existingFile.file_link" target="_blank">{{ $t('general.download') }}</a></div>
        </div>
      </p>
    </div>

    <!-- Yeni dosya preview alanı -->
    <div id="preview"></div>

    <!-- PowerPoint Special Settings -->
    <div class="pptx-settings mt-3">
      <div class="form-group row mb-2">
        <label class="col-md-4 col-form-label">
          {{ $t('general.save_as_scorm') }}
        </label>
        <div class="col-md-8 d-flex align-items-center">
          <label class="uk-switch" for="pptx_scorm">
            <input id="pptx_scorm"
                   :checked="isPowerpointScormFile"
                   type="checkbox"
                   @change="onScormChange($event.target.checked)"
            />
            <div class="uk-switch-slider"></div>
          </label>
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-md-4 col-form-label">
          {{ $t('general.timed_pptx') }}
          <i class="uil-info-circle ml-1"
             :uk-tooltip="'title: ' + $t('general.completion_button_activates_after_countdown')"
          ></i>
        </label>
        <div class="col-md-8 d-flex align-items-center">
          <label class="uk-switch" for="pptx_timed">
            <input id="pptx_timed"
                   :checked="isCompletionTimeout"
                   type="checkbox"
                   @change="onTimedPptxChange($event.target.checked)"
            />
            <div class="uk-switch-slider"></div>
          </label>
          <input v-if="isCompletionTimeout"
                 :value="completionTimeout"
                 class="form-control ml-3 pptx-timeout-input"
                 min="1"
                 type="number"
                 @input="$emit('update:completionTimeout', $event.target.value)"
                 @keypress="isNumber($event)"
          />
          <span v-if="isCompletionTimeout" class="ml-2">
            {{ $t("general.minutes") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";

export default {
  name: "DocumentPowerpointDocument",
  props: {
    icon: {
      type: String,
      default: "icon-feather-file-text"
    },
    contentTypeKey: {
      type: String,
      default: "documents.powerpoint_document"
    },
    acceptableFileType: {
      type: String,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    existingFile: {
      type: Object,
      default: null
    },
    fileCategoryId: {
      type: Number,
      default: null
    },
    isPowerpointScormFile: {
      type: Boolean,
      default: false
    },
    isCompletionTimeout: {
      type: Boolean,
      default: false
    },
    completionTimeout: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      isDragging: false,
      uploadId: `uploadPowerpoint_${Math.random().toString(36).substr(2, 9)}`,
      _waitingForFile: false,
    };
  },
  mounted() {
    if (!bridge.isNative) {
      return;
    }
    this._unsubscribePickFile = bridge.on("PICK_FILE_RESULT", (payload) => {
      if (!this._waitingForFile) return;
      this._waitingForFile = false;
      if (!payload.success || !payload.file) return;
      const { name, type, base64 } = payload.file;
      const byteString = atob(base64);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      this.$emit("file-uploaded", new File([ab], name, { type }));
      this.isDragging = false;
    });
  },
  beforeDestroy() {
    if (this._unsubscribePickFile) {
      this._unsubscribePickFile();
    }
  },
  methods: {
    onScormChange(checked) {
      this.$emit('update:isPowerpointScormFile', checked);
      if (checked) {
        this.$emit('update:isCompletionTimeout', false);
      }
    },
    onTimedPptxChange(checked) {
      this.$emit('update:isCompletionTimeout', checked);
      if (checked) {
        this.$emit('update:isPowerpointScormFile', false);
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit('file-uploaded', file);
        this.isDragging = false;
      }
    },
    onUploadClick(event) {
      if (!bridge.isNative) {
        return;
      }
      event.preventDefault();
      this._waitingForFile = true;
      native.pickFile(this.acceptableFileType);
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
/* .uk-switch global olarak width: 60px ama flex icinde varsayilan
   flex-shrink: 1 ile daraliyordu. Slider `position: absolute; inset: 0`
   ile daralan kutuyu takip ediyor, yuvarlak dugmesi ise sabit boyutlu —
   raydan tasip yanindaki input'un uzerine biniyordu. */
.uk-switch {
  flex-shrink: 0;
}

/* Inline `style="width: 80px"` yerine: flex item olarak da daralmasin */
.pptx-timeout-input {
  flex: 0 0 80px;
  width: 80px;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
}

.dragBox.draging {
  transform: scale(1.05);
  border-color: #666;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}

.file-info {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.file-info div {
  margin-bottom: 8px;
}

.file-info span {
  font-weight: 600;
  color: #333;
}

.file-info a {
  color: #007bff;
  text-decoration: none;
}

.file-info a:hover {
  text-decoration: underline;
}
</style>

